const fadeIn = {
  mounted() {
    this.el.style.opacity = 0;
    setTimeout( () => this.el.style.opacity = 1, 100)
  },
}

const slideInFromRight = {
  mounted() {
    setTimeout( () => this.el.style.right = 0, 10)
  }
}

const scrollToCenter = {
  mounted() {
    let button = this.el
    button.addEventListener('click', function () {
      const container = button.parentElement;
      const containerRect = container.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();

      // Calculate the difference between the center of the container and the center of the button
      const offset = buttonRect.left - containerRect.left + (buttonRect.width / 2) - (containerRect.width / 2);

      // Scroll the container by the calculated offset
      container.scrollBy({
        left: offset,
        behavior: 'smooth'
      });
    })
  }
}

const animateCustom = {
  mounted() {
    let postAnimClasses = this.el.dataset["postAnimClass"]
    let element = this.el
    setTimeout(function() {
      postAnimClasses.split(" ").forEach( (cl) => element.classList.add(cl) )
    }, 10)
  }
}

export default { fadeIn, slideInFromRight, scrollToCenter, animateCustom }
